 <h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ "exitWindow.txtTitle3" | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content style="text-align: center;">
     <div class="block-icon d-flex align-items-center justify-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" height="98px" viewBox="0 -960 960 960" width="98px" fill="#d0d0d0">
            <path d="M440-450q13 0 21.5-9t8.5-21q0-13-8.5-21.5T440-510q-12 0-21 8.5t-9 21.5q0 12 9 21t21 9ZM260-120v-60l280-49v-466q0-14-7.5-24.5T512-732l-252-39v-59l266 46q32 5 53 30.5t21 57.5v516l-340 60Zm-140 0v-60h80v-590q0-26 17.5-43t42.5-17h440q26 0 43 17t17 43v590h80v60H120Zm140-60h440v-590H260v-1 591Z"/>
        </svg>
     </div>
     <div class="block-name">{{ "exitWindow.txtName3" | translate }}</div>
     <div class="block-descriptions" innerHtml="{{ 'exitWindow.txtDescription' | translate }}"></div>

 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick(true)">
             <span>{{ 'buttons.txtYes' | translate }}</span>
         </button>

         <button class="btn-cancel" (click)="onNoClick()" >
             <span>{{ 'buttons.txtNo' | translate }}</span>
         </button> 
     </div>       
   </mat-dialog-actions>
